var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('detail-view',{attrs:{"disableModify":"","endpoint":_vm.endpoint + 'apikeys',"name":"API Key","parentRoute":"apikeys","permissions":"apikeys","values":_vm.values}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-990ef07a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ApiKeyEdit.vue
// module id = HAUO
// module chunks = 1